var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9712 6.39502C11.6952 6.39502 11.4712 6.61902 11.4712 6.89502C11.4712 9.65202 9.22819 11.895 6.47119 11.895C3.71419 11.895 1.47119 9.65202 1.47119 6.89502C1.47119 4.13802 3.71419 1.89502 6.47119 1.89502C7.81344 1.89502 9.07344 2.41952 10.0192 3.37202C10.2137 3.56777 10.5304 3.56902 10.7262 3.37452C10.9222 3.18002 10.9232 2.86327 10.7287 2.66727C9.59394 1.52452 8.08169 0.89502 6.47119 0.89502C3.16269 0.89502 0.471191 3.58652 0.471191 6.89502C0.471191 10.2035 3.16269 12.895 6.47119 12.895C9.77944 12.895 12.4712 10.2035 12.4712 6.89502C12.4712 6.61902 12.2472 6.39502 11.9712 6.39502Z",
    fill: "#F99B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17813 6.89508L8.32463 5.74858C8.51988 5.55333 8.51988 5.23683 8.32463 5.04158C8.12938 4.84633 7.81288 4.84633 7.61763 5.04158L6.47113 6.18808L5.32463 5.04158C5.12963 4.84633 4.81263 4.84633 4.61763 5.04158C4.42238 5.23683 4.42238 5.55333 4.61763 5.74858L5.76413 6.89508L4.61763 8.04158C4.42238 8.23683 4.42238 8.55333 4.61763 8.74858C4.71513 8.84633 4.84313 8.89508 4.97113 8.89508C5.09913 8.89508 5.22713 8.84633 5.32463 8.74858L6.47113 7.60208L7.61763 8.74858C7.71538 8.84633 7.84313 8.89508 7.97113 8.89508C8.09913 8.89508 8.22688 8.84633 8.32463 8.74858C8.51988 8.55333 8.51988 8.23683 8.32463 8.04158L7.17813 6.89508Z",
    fill: "#F99B9B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.471191 0.89502)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.6768605228e73f59ce156a111c3bb2c7.svg";
export { ForwardRef as ReactComponent };